import { Link } from "react-router-dom";


function ResourceLinkBlock(props) {

  // Define variables
  const subTitle = props.subTitle;
  const title = props.title;
  const level = props.level;
  const description = props.description;
  const url = props.url;


  // Screen components
  let levelElement;
  if( level ) {
    levelElement = <p><small>Level: {level}</small></p>;
  }


  return(
    <Link to={url} class='resource-container' target='_blank'>
      <p>
        <small><i>{subTitle}</i></small>
        <br />
        <strong>{title}</strong>
        {levelElement}
      </p>
      <p>
        {description}
      </p>
    </Link>
  );
}

export default ResourceLinkBlock;